import React from 'react';
import { NetWorthContent } from './NetWorthStyles';
import { NetWorthChartEmpty } from './NetWorthChart/NetWorthChartEmpty';
import { NetWorthTableEmpty } from './NetWorthTable/NetWorthTableEmpty';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { NETWORTH_DESCRIPTION } from './NetWorth.meta';

export const NetWorthEmpty = () => {
  return (
    <>
      <Text as="p" fontSize="h6" mt="12">
        {NETWORTH_DESCRIPTION}
      </Text>
      <NetWorthContent>
        <NetWorthChartEmpty />
        <NetWorthTableEmpty />
      </NetWorthContent>
    </>
  );
};
